import { BreadCrumb } from "@/components";
import classNames from "classnames";
import { useState } from "react";
import {
  Container,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from "reactstrap";
import { CampaignTypeTab, ChannelTab } from "./tabs";

const TABS = [
  {
    label: "Channel",
    value: "channel",
    component: <ChannelTab />,
  },
  {
    label: "Campaign Type",
    value: "campaignType",
    component: <CampaignTypeTab />,
  },
];

const CampaignManagement = () => {
  const [activeTab, setActiveTab] = useState(TABS[0].value);

  const toggle = (tab: string) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb title="Campaign Management" />
        <div>
          <Nav tabs className="bg-white">
            {TABS.map((tab) => (
              <NavItem key={tab.value} className="cursor-pointer">
                <NavLink
                  id={tab.value}
                  className={classNames({ active: activeTab === tab.value })}
                  onClick={() => toggle(tab.value)}
                >
                  {tab.label}
                </NavLink>
              </NavItem>
            ))}
          </Nav>
          <TabContent activeTab={activeTab}>
            {TABS.map((tab) => (
              <TabPane key={tab.value} tabId={tab.value}>
                {activeTab === tab.value && tab.component}
              </TabPane>
            ))}
          </TabContent>
        </div>
      </Container>
    </div>
  );
};

export default CampaignManagement;
